function profile(backendAxiosInstance) {
  const profileBaseUrl = "/customer/v1/profiles";
  async function getProfiles() {
    return backendAxiosInstance.get(profileBaseUrl);
  }
  async function getProfile(profileId) {
    return backendAxiosInstance.get(`${profileBaseUrl}/${profileId}`);
  }
  async function createProfile(profileData) {
    return backendAxiosInstance.post(
      profileBaseUrl,
      {
        ...profileData
      }
    );
  }
  async function deleteProfile(profileId) {
    return backendAxiosInstance.delete(`${profileBaseUrl}/${profileId}`);
  }
  async function patchProfile(profileId, profileData) {
    return backendAxiosInstance.patch(`${profileBaseUrl}/${profileId}`, {
      ...profileData
    });
  }
  return {
    getProfiles,
    getProfile,
    createProfile,
    deleteProfile,
    patchProfile
  };
}

export { profile as default };
//# sourceMappingURL=profile.js.map
